import axios from 'axios';
import Cookies from 'js-cookie';

import { getStorage, removeStorage, setStorage } from '../utils/auth-utils';
import { Api_routes, server_url } from './API_Routes';

const postRequest = async (url, data, headers, signal) => {
  return new Promise((resolve, reject) => {
    axios
      .post(url, data, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
          ...headers,
        },
        signal,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          return;
        }
        if (error.response?.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          // window.location.reload();
        }
        resolve(error.response?.data);
      });
  });
};

const getRequest = async (url, queryParams, headers, signal) => {
  return new Promise((resolve, reject) => {
    axios
      .get(url, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
          ...headers,
        },
        params: queryParams,
        signal,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.name === 'CanceledError' || error.name === 'AbortError') {
          return;
        }
        if (error.response?.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          // window.location.reload();
        }
        resolve(error.response?.data);
      });
  });
};

const deleteRequest = async (url, queryParams) => {
  return new Promise((resolve, reject) => {
    axios
      .delete(url, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
        params: queryParams,
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response?.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        } else resolve(error.response?.data);
      });
  });
};

const putRequest = async (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .put(url, data, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response?.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response?.data);
      });
  });
};

const patchRequest = async (url, data) => {
  return new Promise((resolve, reject) => {
    axios
      .patch(url, data, {
        headers: {
          Authorization: getStorage('token'),
          'Content-Type': 'application/json',
        },
      })
      .then((response) => {
        resolve(response?.data);
      })
      .catch(async (error) => {
        if (error.response?.status === 401) {
          removeStorage('token');
          Cookies.remove('access_token');
          Cookies.remove('refresh_token');
          window.location.reload();
        }
        resolve(error.response?.data);
      });
  });
};

const getNewToken = async (refreshToken) => {
  const url = server_url + import.meta.env.REACT_APP_AUTH_SERVER_PORT + Api_routes.refreshToken;
  return new Promise((resolve, reject) => {
    axios
      .post(
        url,
        {
          refreshToken,
        },
        {
          headers: {
            'Content-Type': 'application/json',
          },
        }
      )
      .then(async (response) => {
        setStorage('token', response.data.data.token);
        resolve(response?.data);
      })
      .catch(async (error) => {
        reject(error.response?.data);
      });
  });
};

const ciIdentify = (data) => {
  window._cio.identify({ ...data });
};

export { postRequest, getRequest, deleteRequest, putRequest, patchRequest, ciIdentify, getNewToken };
